import moment from "moment";

import { Toast }        from "./toasts";
import { OnSchedUtils } from ".";

import { GetAvailability } from "../actions/availabilityActions";
import { GetLocation }     from "../actions/locationActions";


export const JumpToFirstAvailable = (element, availableDays, picker, date, setDate) => {
  const disabledDates = availableDays.filter(d => !d.available).map(d => new Date(moment(d.date)));
  const firstAvailableDay = availableDays.filter(d => d.available)[0];

  if (firstAvailableDay) {
    if (!disabledDates.map(d => moment(d).format("YYYY-MM-DD")).includes(date)) {
      picker.setDate(new Date(moment(date)), true);
      setDate(moment(date).format('YYYY-MM-DD'));
    }
    else if (availableDays.filter(d => d.available)?.length) {
      picker.setDate(new Date(moment(availableDays.filter(d => d.available)[0].date)), true);
      setDate(moment(availableDays.filter(d => d.available)[0].date).format('YYYY-MM-DD'));
    }
    else {
      Toast(element, { error: true, message: 'No available dates found' });
    }
  }
}

export const AvailableTimes = (meridiem) => ({
  0: {
    displayTime: meridiem ? '12:00 ' + 'am' : '12:00',
    label: '12:00',
    name: '12:00',
    meridiem: 'am',
    value: 0
  },
  5: {
    displayTime: meridiem ? '12:05 ' + 'am' : '12:05',
    label: '12:05',
    name: '12:05',
    meridiem: 'am',
    value: 5
  },
  10: {
    displayTime: meridiem ? '12:10 ' + 'am' : '12:10',
    label: '12:10',
    name: '12:10',
    meridiem: 'am',
    value: 10
  },
  15: {
    displayTime: meridiem ? '12:15 ' + 'am' : '12:15',
    label: '12:15',
    name: '12:15',
    meridiem: 'am',
    value: 15
  },
  20: {
    displayTime: meridiem ? '12:20 ' + 'am' : '12:20',
    label: '12:20',
    name: '12:20',
    meridiem: 'am',
    value: 20
  },
  25: {
    displayTime: meridiem ? '12:25 ' + 'am' : '12:25',
    label: '12:25',
    name: '12:25',
    meridiem: 'am',
    value: 25
  },
  30: {
    displayTime: meridiem ? '12:30 ' + 'am' : '12:30',
    label: '12:30',
    name: '12:30',
    meridiem: 'am',
    value: 30
  },
  35: {
    displayTime: meridiem ? '12:35 ' + 'am' : '12:35',
    label: '12:35',
    name: '12:35',
    meridiem: 'am',
    value: 35
  },
  40: {
    displayTime: meridiem ? '12:40 ' + 'am' : '12:40',
    label: '12:40',
    name: '12:40',
    meridiem: 'am',
    value: 40
  },
  45: {
    displayTime: meridiem ? '12:45 ' + 'am' : '12:45',
    label: '12:45',
    name: '12:45',
    meridiem: 'am',
    value: 45
  },
  50: {
    displayTime: meridiem ? '12:50 ' + 'am' : '12:50',
    label: '12:50',
    name: '12:50',
    meridiem: 'am',
    value: 50
  },
  55: {
    displayTime: meridiem ? '12:55 ' + 'am' : '12:55',
    label: '12:55',
    name: '12:55',
    meridiem: 'am',
    value: 55
  },
  100: {
    displayTime: meridiem ? '1:00 ' + 'am' : '1:00',
    label: '1:00',
    name: '1:00',
    meridiem: 'am',
    value: 100
  },
  105: {
    displayTime: meridiem ? '1:05 ' + 'am' : '1:05',
    label: '1:05',
    name: '1:05',
    meridiem: 'am',
    value: 105
  },
  110: {
    displayTime: meridiem ? '1:10 ' + 'am' : '1:10',
    label: '1:10',
    name: '1:10',
    meridiem: 'am',
    value: 110
  },
  115: {
    displayTime: meridiem ? '1:15 ' + 'am' : '1:15',
    label: '1:15',
    name: '1:15',
    meridiem: 'am',
    value: 115
  },
  120: {
    displayTime: meridiem ? '1:20 ' + 'am' : '1:20',
    label: '1:20',
    name: '1:20',
    meridiem: 'am',
    value: 120
  },
  125: {
    displayTime: meridiem ? '1:25 ' + 'am' : '1:25',
    label: '1:25',
    name: '1:25',
    meridiem: 'am',
    value: 125
  },
  130: {
    displayTime: meridiem ? '1:30 ' + 'am' : '1:30',
    label: '1:30',
    name: '1:30',
    meridiem: 'am',
    value: 130
  },
  135: {
    displayTime: meridiem ? '1:35 ' + 'am' : '1:35',
    label: '1:35',
    name: '1:35',
    meridiem: 'am',
    value: 135
  },
  140: {
    displayTime: meridiem ? '1:40 ' + 'am' : '1:40',
    label: '1:40',
    name: '1:40',
    meridiem: 'am',
    value: 140
  },
  145: {
    displayTime: meridiem ? '1:45 ' + 'am' : '1:45',
    label: '1:45',
    name: '1:45',
    meridiem: 'am',
    value: 145
  },
  150: {
    displayTime: meridiem ? '1:50 ' + 'am' : '1:50',
    label: '1:50',
    name: '1:50',
    meridiem: 'am',
    value: 150
  },
  155: {
    displayTime: meridiem ? '1:55 ' + 'am' : '1:55',
    label: '1:55',
    name: '1:55',
    meridiem: 'am',
    value: 155
  },
  200: {
    displayTime: meridiem ? '2:00 ' + 'am' : '2:00',
    label: '2:00',
    name: '2:00',
    meridiem: 'am',
    value: 200
  },
  205: {
    displayTime: meridiem ? '2:05 ' + 'am' : '2:05',
    label: '2:05',
    name: '2:05',
    meridiem: 'am',
    value: 205
  },
  210: {
    displayTime: meridiem ? '2:10 ' + 'am' : '2:10',
    label: '2:10',
    name: '2:10',
    meridiem: 'am',
    value: 210
  },
  215: {
    displayTime: meridiem ? '2:15 ' + 'am' : '2:15',
    label: '2:15',
    name: '2:15',
    meridiem: 'am',
    value: 215
  },
  220: {
    displayTime: meridiem ? '2:20 ' + 'am' : '2:20',
    label: '2:20',
    name: '2:20',
    meridiem: 'am',
    value: 220
  },
  225: {
    displayTime: meridiem ? '2:25 ' + 'am' : '2:25',
    label: '2:25',
    name: '2:25',
    meridiem: 'am',
    value: 225
  },
  230: {
    displayTime: meridiem ? '2:30 ' + 'am' : '2:30',
    label: '2:30',
    name: '2:30',
    meridiem: 'am',
    value: 230
  },
  235: {
    displayTime: meridiem ? '2:35 ' + 'am' : '2:35',
    label: '2:35',
    name: '2:35',
    meridiem: 'am',
    value: 235
  },
  240: {
    displayTime: meridiem ? '2:40 ' + 'am' : '2:40',
    label: '2:40',
    name: '2:40',
    meridiem: 'am',
    value: 240
  },
  245: {
    displayTime: meridiem ? '2:45 ' + 'am' : '2:45',
    label: '2:45',
    name: '2:45',
    meridiem: 'am',
    value: 245
  },
  250: {
    displayTime: meridiem ? '2:50 ' + 'am' : '2:50',
    label: '2:50',
    name: '2:50',
    meridiem: 'am',
    value: 250
  },
  255: {
    displayTime: meridiem ? '2:55 ' + 'am' : '2:55',
    label: '2:55',
    name: '2:55',
    meridiem: 'am',
    value: 255
  },
  300: {
    displayTime: meridiem ? '3:00 ' + 'am' : '3:00',
    label: '3:00',
    name: '3:00',
    meridiem: 'am',
    value: 300
  },
  305: {
    displayTime: meridiem ? '3:05 ' + 'am' : '3:05',
    label: '3:05',
    name: '3:05',
    meridiem: 'am',
    value: 305
  },
  310: {
    displayTime: meridiem ? '3:10 ' + 'am' : '3:10',
    label: '3:10',
    name: '3:10',
    meridiem: 'am',
    value: 310
  },
  315: {
    displayTime: meridiem ? '3:15 ' + 'am' : '3:15',
    label: '3:15',
    name: '3:15',
    meridiem: 'am',
    value: 315
  },
  320: {
    displayTime: meridiem ? '3:20 ' + 'am' : '3:20',
    label: '3:20',
    name: '3:20',
    meridiem: 'am',
    value: 320
  },
  325: {
    displayTime: meridiem ? '3:25 ' + 'am' : '3:25',
    label: '3:25',
    name: '3:25',
    meridiem: 'am',
    value: 325
  },
  330: {
    displayTime: meridiem ? '3:30 ' + 'am' : '3:30',
    label: '3:30',
    name: '3:30',
    meridiem: 'am',
    value: 330
  },
  335: {
    displayTime: meridiem ? '3:35 ' + 'am' : '3:35',
    label: '3:35',
    name: '3:35',
    meridiem: 'am',
    value: 335
  },
  340: {
    displayTime: meridiem ? '3:40 ' + 'am' : '3:40',
    label: '3:40',
    name: '3:40',
    meridiem: 'am',
    value: 340
  },
  345: {
    displayTime: meridiem ? '3:45 ' + 'am' : '3:45',
    label: '3:45',
    name: '3:45',
    meridiem: 'am',
    value: 345
  },
  350: {
    displayTime: meridiem ? '3:50 ' + 'am' : '3:50',
    label: '3:50',
    name: '3:50',
    meridiem: 'am',
    value: 350
  },
  355: {
    displayTime: meridiem ? '3:55 ' + 'am' : '3:55',
    label: '3:55',
    name: '3:55',
    meridiem: 'am',
    value: 355
  },
  400: {
    displayTime: meridiem ? '4:00 ' + 'am' : '4:00',
    label: '4:00',
    name: '4:00',
    meridiem: 'am',
    value: 400
  },
  405: {
    displayTime: meridiem ? '4:05 ' + 'am' : '4:05',
    label: '4:05',
    name: '4:05',
    meridiem: 'am',
    value: 405
  },
  410: {
    displayTime: meridiem ? '4:10 ' + 'am' : '4:10',
    label: '4:10',
    name: '4:10',
    meridiem: 'am',
    value: 410
  },
  415: {
    displayTime: meridiem ? '4:15 ' + 'am' : '4:15',
    label: '4:15',
    name: '4:15',
    meridiem: 'am',
    value: 415
  },
  420: {
    displayTime: meridiem ? '4:20 ' + 'am' : '4:20',
    label: '4:20',
    name: '4:20',
    meridiem: 'am',
    value: 420
  },
  425: {
    displayTime: meridiem ? '4:25 ' + 'am' : '4:25',
    label: '4:25',
    name: '4:25',
    meridiem: 'am',
    value: 425
  },
  430: {
    displayTime: meridiem ? '4:30 ' + 'am' : '4:30',
    label: '4:30',
    name: '4:30',
    meridiem: 'am',
    value: 430
  },
  435: {
    displayTime: meridiem ? '4:35 ' + 'am' : '4:35',
    label: '4:35',
    name: '4:35',
    meridiem: 'am',
    value: 435
  },
  440: {
    displayTime: meridiem ? '4:40 ' + 'am' : '4:40',
    label: '4:40',
    name: '4:40',
    meridiem: 'am',
    value: 440
  },
  445: {
    displayTime: meridiem ? '4:45 ' + 'am' : '4:45',
    label: '4:45',
    name: '4:45',
    meridiem: 'am',
    value: 445
  },
  450: {
    displayTime: meridiem ? '4:50 ' + 'am' : '4:50',
    label: '4:50',
    name: '4:50',
    meridiem: 'am',
    value: 450
  },
  455: {
    displayTime: meridiem ? '4:55 ' + 'am' : '4:55',
    label: '4:55',
    name: '4:55',
    meridiem: 'am',
    value: 455
  },
  500: {
    displayTime: meridiem ? '5:00 ' + 'am' : '5:00',
    label: '5:00',
    name: '5:00',
    meridiem: 'am',
    value: 500
  },
  505: {
    displayTime: meridiem ? '5:05 ' + 'am' : '5:05',
    label: '5:05',
    name: '5:05',
    meridiem: 'am',
    value: 505
  },
  510: {
    displayTime: meridiem ? '5:10 ' + 'am' : '5:10',
    label: '5:10',
    name: '5:10',
    meridiem: 'am',
    value: 510
  },
  515: {
    displayTime: meridiem ? '5:15 ' + 'am' : '5:15',
    label: '5:15',
    name: '5:15',
    meridiem: 'am',
    value: 515
  },
  520: {
    displayTime: meridiem ? '5:20 ' + 'am' : '5:20',
    label: '5:20',
    name: '5:20',
    meridiem: 'am',
    value: 520
  },
  525: {
    displayTime: meridiem ? '5:25 ' + 'am' : '5:25',
    label: '5:25',
    name: '5:25',
    meridiem: 'am',
    value: 525
  },
  530: {
    displayTime: meridiem ? '5:30 ' + 'am' : '5:30',
    label: '5:30',
    name: '5:30',
    meridiem: 'am',
    value: 530
  },
  535: {
    displayTime: meridiem ? '5:35 ' + 'am' : '5:35',
    label: '5:35',
    name: '5:35',
    meridiem: 'am',
    value: 535
  },
  540: {
    displayTime: meridiem ? '5:40 ' + 'am' : '5:40',
    label: '5:40',
    name: '5:40',
    meridiem: 'am',
    value: 540
  },
  545: {
    displayTime: meridiem ? '5:45 ' + 'am' : '5:45',
    label: '5:45',
    name: '5:45',
    meridiem: 'am',
    value: 545
  },
  550: {
    displayTime: meridiem ? '5:50 ' + 'am' : '5:50',
    label: '5:50',
    name: '5:50',
    meridiem: 'am',
    value: 550
  },
  555: {
    displayTime: meridiem ? '5:55 ' + 'am' : '5:55',
    label: '5:55',
    name: '5:55',
    meridiem: 'am',
    value: 555
  },
  600: {
    displayTime: meridiem ? '6:00 ' + 'am' : '6:00',
    label: '6:00',
    name: '6:00',
    meridiem: 'am',
    value: 600
  },
  605: {
    displayTime: meridiem ? '6:05 ' + 'am' : '6:05',
    label: '6:05',
    name: '6:05',
    meridiem: 'am',
    value: 605
  },
  610: {
    displayTime: meridiem ? '6:10 ' + 'am' : '6:10',
    label: '6:10',
    name: '6:10',
    meridiem: 'am',
    value: 610
  },
  615: {
    displayTime: meridiem ? '6:15 ' + 'am' : '6:15',
    label: '6:15',
    name: '6:15',
    meridiem: 'am',
    value: 615
  },
  620: {
    displayTime: meridiem ? '6:20 ' + 'am' : '6:20',
    label: '6:20',
    name: '6:20',
    meridiem: 'am',
    value: 620
  },
  625: {
    displayTime: meridiem ? '6:25 ' + 'am' : '6:25',
    label: '6:25',
    name: '6:25',
    meridiem: 'am',
    value: 625
  },
  630: {
    displayTime: meridiem ? '6:30 ' + 'am' : '6:30',
    label: '6:30',
    name: '6:30',
    meridiem: 'am',
    value: 630
  },
  635: {
    displayTime: meridiem ? '6:35 ' + 'am' : '6:35',
    label: '6:35',
    name: '6:35',
    meridiem: 'am',
    value: 635
  },
  640: {
    displayTime: meridiem ? '6:40 ' + 'am' : '6:40',
    label: '6:40',
    name: '6:40',
    meridiem: 'am',
    value: 640
  },
  645: {
    displayTime: meridiem ? '6:45 ' + 'am' : '6:45',
    label: '6:45',
    name: '6:45',
    meridiem: 'am',
    value: 645
  },
  650: {
    displayTime: meridiem ? '6:50 ' + 'am' : '6:50',
    label: '6:50',
    name: '6:50',
    meridiem: 'am',
    value: 650
  },
  655: {
    displayTime: meridiem ? '6:55 ' + 'am' : '6:55',
    label: '6:55',
    name: '6:55',
    meridiem: 'am',
    value: 655
  },
  700: {
    displayTime: meridiem ? '7:00 ' + 'am' : '7:00',
    label: '7:00',
    name: '7:00',
    meridiem: 'am',
    value: 700
  },
  705: {
    displayTime: meridiem ? '7:05 ' + 'am' : '7:05',
    label: '7:05',
    name: '7:05',
    meridiem: 'am',
    value: 705
  },
  710: {
    displayTime: meridiem ? '7:10 ' + 'am' : '7:10',
    label: '7:10',
    name: '7:10',
    meridiem: 'am',
    value: 710
  },
  715: {
    displayTime: meridiem ? '7:15 ' + 'am' : '7:15',
    label: '7:15',
    name: '7:15',
    meridiem: 'am',
    value: 715
  },
  720: {
    displayTime: meridiem ? '7:20 ' + 'am' : '7:20',
    label: '7:20',
    name: '7:20',
    meridiem: 'am',
    value: 720
  },
  725: {
    displayTime: meridiem ? '7:25 ' + 'am' : '7:25',
    label: '7:25',
    name: '7:25',
    meridiem: 'am',
    value: 725
  },
  730: {
    displayTime: meridiem ? '7:30 ' + 'am' : '7:30',
    label: '7:30',
    name: '7:30',
    meridiem: 'am',
    value: 730
  },
  735: {
    displayTime: meridiem ? '7:35 ' + 'am' : '7:35',
    label: '7:35',
    name: '7:35',
    meridiem: 'am',
    value: 735
  },
  740: {
    displayTime: meridiem ? '7:40 ' + 'am' : '7:40',
    label: '7:40',
    name: '7:40',
    meridiem: 'am',
    value: 740
  },
  745: {
    displayTime: meridiem ? '7:45 ' + 'am' : '7:45',
    label: '7:45',
    name: '7:45',
    meridiem: 'am',
    value: 745
  },
  750: {
    displayTime: meridiem ? '7:50 ' + 'am' : '7:50',
    label: '7:50',
    name: '7:50',
    meridiem: 'am',
    value: 750
  },
  755: {
    displayTime: meridiem ? '7:55 ' + 'am' : '7:55',
    label: '7:55',
    name: '7:55',
    meridiem: 'am',
    value: 755
  },
  800: {
    displayTime: meridiem ? '8:00 ' + 'am' : '8:00',
    label: '8:00',
    name: '8:00',
    meridiem: 'am',
    value: 800
  },
  805: {
    displayTime: meridiem ? '8:05 ' + 'am' : '8:05',
    label: '8:05',
    name: '8:05',
    meridiem: 'am',
    value: 805
  },
  810: {
    displayTime: meridiem ? '8:10 ' + 'am' : '8:10',
    label: '8:10',
    name: '8:10',
    meridiem: 'am',
    value: 810
  },
  815: {
    displayTime: meridiem ? '8:15 ' + 'am' : '8:15',
    label: '8:15',
    name: '8:15',
    meridiem: 'am',
    value: 815
  },
  820: {
    displayTime: meridiem ? '8:20 ' + 'am' : '8:20',
    label: '8:20',
    name: '8:20',
    meridiem: 'am',
    value: 820
  },
  825: {
    displayTime: meridiem ? '8:25 ' + 'am' : '8:25',
    label: '8:25',
    name: '8:25',
    meridiem: 'am',
    value: 825
  },
  830: {
    displayTime: meridiem ? '8:30 ' + 'am' : '8:30',
    label: '8:30',
    name: '8:30',
    meridiem: 'am',
    value: 830
  },
  835: {
    displayTime: meridiem ? '8:35 ' + 'am' : '8:35',
    label: '8:35',
    name: '8:35',
    meridiem: 'am',
    value: 835
  },
  840: {
    displayTime: meridiem ? '8:40 ' + 'am' : '8:40',
    label: '8:40',
    name: '8:40',
    meridiem: 'am',
    value: 840
  },
  845: {
    displayTime: meridiem ? '8:45 ' + 'am' : '8:45',
    label: '8:45',
    name: '8:45',
    meridiem: 'am',
    value: 845
  },
  850: {
    displayTime: meridiem ? '8:50 ' + 'am' : '8:50',
    label: '8:50',
    name: '8:50',
    meridiem: 'am',
    value: 850
  },
  855: {
    displayTime: meridiem ? '8:55 ' + 'am' : '8:55',
    label: '8:55',
    name: '8:55',
    meridiem: 'am',
    value: 855
  },
  900: {
    displayTime: meridiem ? '9:00 ' + 'am' : '9:00',
    label: '9:00',
    name: '9:00',
    meridiem: 'am',
    value: 900
  },
  905: {
    displayTime: meridiem ? '9:05 ' + 'am' : '9:05',
    label: '9:05',
    name: '9:05',
    meridiem: 'am',
    value: 905
  },
  910: {
    displayTime: meridiem ? '9:10 ' + 'am' : '9:10',
    label: '9:10',
    name: '9:10',
    meridiem: 'am',
    value: 910
  },
  915: {
    displayTime: meridiem ? '9:15 ' + 'am' : '9:15',
    label: '9:15',
    name: '9:15',
    meridiem: 'am',
    value: 915
  },
  920: {
    displayTime: meridiem ? '9:20 ' + 'am' : '9:20',
    label: '9:20',
    name: '9:20',
    meridiem: 'am',
    value: 920
  },
  925: {
    displayTime: meridiem ? '9:25 ' + 'am' : '9:25',
    label: '9:25',
    name: '9:25',
    meridiem: 'am',
    value: 925
  },
  930: {
    displayTime: meridiem ? '9:30 ' + 'am' : '9:30',
    label: '9:30',
    name: '9:30',
    meridiem: 'am',
    value: 930
  },
  935: {
    displayTime: meridiem ? '9:35 ' + 'am' : '9:35',
    label: '9:35',
    name: '9:35',
    meridiem: 'am',
    value: 935
  },
  940: {
    displayTime: meridiem ? '9:40 ' + 'am' : '9:40',
    label: '9:40',
    name: '9:40',
    meridiem: 'am',
    value: 940
  },
  945: {
    displayTime: meridiem ? '9:45 ' + 'am' : '9:45',
    label: '9:45',
    name: '9:45',
    meridiem: 'am',
    value: 945
  },
  950: {
    displayTime: meridiem ? '9:50 ' + 'am' : '9:50',
    label: '9:50',
    name: '9:50',
    meridiem: 'am',
    value: 950
  },
  955: {
    displayTime: meridiem ? '9:55 ' + 'am' : '9:55',
    label: '9:55',
    name: '9:55',
    meridiem: 'am',
    value: 955
  },
  1000: {
    displayTime: meridiem ? '10:00 ' + 'am' : '10:00',
    label: '10:00',
    name: '10:00',
    meridiem: 'am',
    value: 1000
  },
  1005: {
    displayTime: meridiem ? '10:05 ' + 'am' : '10:05',
    label: '10:05',
    name: '10:05',
    meridiem: 'am',
    value: 1005
  },
  1010: {
    displayTime: meridiem ? '10:10 ' + 'am' : '10:10',
    label: '10:10',
    name: '10:10',
    meridiem: 'am',
    value: 1010
  },
  1015: {
    displayTime: meridiem ? '10:15 ' + 'am' : '10:15',
    label: '10:15',
    name: '10:15',
    meridiem: 'am',
    value: 1015
  },
  1020: {
    displayTime: meridiem ? '10:20 ' + 'am' : '10:20',
    label: '10:20',
    name: '10:20',
    meridiem: 'am',
    value: 1020
  },
  1025: {
    displayTime: meridiem ? '10:25 ' + 'am' : '10:25',
    label: '10:25',
    name: '10:25',
    meridiem: 'am',
    value: 1025
  },
  1030: {
    displayTime: meridiem ? '10:30 ' + 'am' : '10:30',
    label: '10:30',
    name: '10:30',
    meridiem: 'am',
    value: 1030
  },
  1035: {
    displayTime: meridiem ? '10:35 ' + 'am' : '10:35',
    label: '10:35',
    name: '10:35',
    meridiem: 'am',
    value: 1035
  },
  1040: {
    displayTime: meridiem ? '10:40 ' + 'am' : '10:40',
    label: '10:40',
    name: '10:40',
    meridiem: 'am',
    value: 1040
  },
  1045: {
    displayTime: meridiem ? '10:45 ' + 'am' : '10:45',
    label: '10:45',
    name: '10:45',
    meridiem: 'am',
    value: 1045
  },
  1050: {
    displayTime: meridiem ? '10:50 ' + 'am' : '10:50',
    label: '10:50',
    name: '10:50',
    meridiem: 'am',
    value: 1050
  },
  1055: {
    displayTime: meridiem ? '10:55 ' + 'am' : '10:55',
    label: '10:55',
    name: '10:55',
    meridiem: 'am',
    value: 1055
  },
  1100: {
    displayTime: meridiem ? '11:00 ' + 'am' : '11:00',
    label: '11:00',
    name: '11:00',
    meridiem: 'am',
    value: 1100
  },
  1105: {
    displayTime: meridiem ? '11:05 ' + 'am' : '11:05',
    label: '11:05',
    name: '11:05',
    meridiem: 'am',
    value: 1105
  },
  1110: {
    displayTime: meridiem ? '11:10 ' + 'am' : '11:10',
    label: '11:10',
    name: '11:10',
    meridiem: 'am',
    value: 1110
  },
  1115: {
    displayTime: meridiem ? '11:15 ' + 'am' : '11:15',
    label: '11:15',
    name: '11:15',
    meridiem: 'am',
    value: 1115
  },
  1120: {
    displayTime: meridiem ? '11:20 ' + 'am' : '11:20',
    label: '11:20',
    name: '11:20',
    meridiem: 'am',
    value: 1120
  },
  1125: {
    displayTime: meridiem ? '11:25 ' + 'am' : '11:25',
    label: '11:25',
    name: '11:25',
    meridiem: 'am',
    value: 1125
  },
  1130: {
    displayTime: meridiem ? '11:30 ' + 'am' : '11:30',
    label: '11:30',
    name: '11:30',
    meridiem: 'am',
    value: 1130
  },
  1135: {
    displayTime: meridiem ? '11:35 ' + 'am' : '11:35',
    label: '11:35',
    name: '11:35',
    meridiem: 'am',
    value: 1135
  },
  1140: {
    displayTime: meridiem ? '11:40 ' + 'am' : '11:40',
    label: '11:40',
    name: '11:40',
    meridiem: 'am',
    value: 1140
  },
  1145: {
    displayTime: meridiem ? '11:45 ' + 'am' : '11:45',
    label: '11:45',
    name: '11:45',
    meridiem: 'am',
    value: 1145
  },
  1150: {
    displayTime: meridiem ? '11:50 ' + 'am' : '11:50',
    label: '11:50',
    name: '11:50',
    meridiem: 'am',
    value: 1150
  },
  1155: {
    displayTime: meridiem ? '11:55 ' + 'am' : '11:55',
    label: '11:55',
    name: '11:55',
    meridiem: 'am',
    value: 1155
  },
  1200: {
    displayTime: meridiem ? '12:00 ' + 'pm' : '12:00',
    label: '12:00',
    name: '12:00',
    meridiem: 'pm',
    value: 1200
  },
  1205: {
    displayTime: meridiem ? '12:05 ' + 'pm' : '12:05',
    label: '12:05',
    name: '12:05',
    meridiem: 'pm',
    value: 1205
  },
  1210: {
    displayTime: meridiem ? '12:10 ' + 'pm' : '12:10',
    label: '12:10',
    name: '12:10',
    meridiem: 'pm',
    value: 1210
  },
  1215: {
    displayTime: meridiem ? '12:15 ' + 'pm' : '12:15',
    label: '12:15',
    name: '12:15',
    meridiem: 'pm',
    value: 1215
  },
  1220: {
    displayTime: meridiem ? '12:20 ' + 'pm' : '12:20',
    label: '12:20',
    name: '12:20',
    meridiem: 'pm',
    value: 1220
  },
  1225: {
    displayTime: meridiem ? '12:25 ' + 'pm' : '12:25',
    label: '12:25',
    name: '12:25',
    meridiem: 'pm',
    value: 1225
  },
  1230: {
    displayTime: meridiem ? '12:30 ' + 'pm' : '12:30',
    label: '12:30',
    name: '12:30',
    meridiem: 'pm',
    value: 1230
  },
  1235: {
    displayTime: meridiem ? '12:35 ' + 'pm' : '12:35',
    label: '12:35',
    name: '12:35',
    meridiem: 'pm',
    value: 1235
  },
  1240: {
    displayTime: meridiem ? '12:40 ' + 'pm' : '12:40',
    label: '12:40',
    name: '12:40',
    meridiem: 'pm',
    value: 1240
  },
  1245: {
    displayTime: meridiem ? '12:45 ' + 'pm' : '12:45',
    label: '12:45',
    name: '12:45',
    meridiem: 'pm',
    value: 1245
  },
  1250: {
    displayTime: meridiem ? '12:50 ' + 'pm' : '12:50',
    label: '12:50',
    name: '12:50',
    meridiem: 'pm',
    value: 1250
  },
  1255: {
    displayTime: meridiem ? '12:55 ' + 'pm' : '12:55',
    label: '12:55',
    name: '12:55',
    meridiem: 'pm',
    value: 1255
  },
  1300: {
    displayTime: meridiem ? '1:00 ' + 'pm' : '1:00',
    label: '1:00',
    name: '1:00',
    meridiem: 'pm',
    value: 1300
  },
  1305: {
    displayTime: meridiem ? '1:05 ' + 'pm' : '1:05',
    label: '1:05',
    name: '1:05',
    meridiem: 'pm',
    value: 1305
  },
  1310: {
    displayTime: meridiem ? '1:10 ' + 'pm' : '1:10',
    label: '1:10',
    name: '1:10',
    meridiem: 'pm',
    value: 1310
  },
  1315: {
    displayTime: meridiem ? '1:15 ' + 'pm' : '1:15',
    label: '1:15',
    name: '1:15',
    meridiem: 'pm',
    value: 1315
  },
  1320: {
    displayTime: meridiem ? '1:20 ' + 'pm' : '1:20',
    label: '1:20',
    name: '1:20',
    meridiem: 'pm',
    value: 1320
  },
  1325: {
    displayTime: meridiem ? '1:25 ' + 'pm' : '1:25',
    label: '1:25',
    name: '1:25',
    meridiem: 'pm',
    value: 1325
  },
  1330: {
    displayTime: meridiem ? '1:30 ' + 'pm' : '1:30',
    label: '1:30',
    name: '1:30',
    meridiem: 'pm',
    value: 1330
  },
  1335: {
    displayTime: meridiem ? '1:35 ' + 'pm' : '1:35',
    label: '1:35',
    name: '1:35',
    meridiem: 'pm',
    value: 1335
  },
  1340: {
    displayTime: meridiem ? '1:40 ' + 'pm' : '1:40',
    label: '1:40',
    name: '1:40',
    meridiem: 'pm',
    value: 1340
  },
  1345: {
    displayTime: meridiem ? '1:45 ' + 'pm' : '1:45',
    label: '1:45',
    name: '1:45',
    meridiem: 'pm',
    value: 1345
  },
  1350: {
    displayTime: meridiem ? '1:50 ' + 'pm' : '1:50',
    label: '1:50',
    name: '1:50',
    meridiem: 'pm',
    value: 1350
  },
  1355: {
    displayTime: meridiem ? '1:55 ' + 'pm' : '1:55',
    label: '1:55',
    name: '1:55',
    meridiem: 'pm',
    value: 1355
  },
  1400: {
    displayTime: meridiem ? '2:00 ' + 'pm' : '2:00',
    label: '2:00',
    name: '2:00',
    meridiem: 'pm',
    value: 1400
  },
  1405: {
    displayTime: meridiem ? '2:05 ' + 'pm' : '2:05',
    label: '2:05',
    name: '2:05',
    meridiem: 'pm',
    value: 1405
  },
  1410: {
    displayTime: meridiem ? '2:10 ' + 'pm' : '2:10',
    label: '2:10',
    name: '2:10',
    meridiem: 'pm',
    value: 1410
  },
  1415: {
    displayTime: meridiem ? '2:15 ' + 'pm' : '2:15',
    label: '2:15',
    name: '2:15',
    meridiem: 'pm',
    value: 1415
  },
  1420: {
    displayTime: meridiem ? '2:20 ' + 'pm' : '2:20',
    label: '2:20',
    name: '2:20',
    meridiem: 'pm',
    value: 1420
  },
  1425: {
    displayTime: meridiem ? '2:25 ' + 'pm' : '2:25',
    label: '2:25',
    name: '2:25',
    meridiem: 'pm',
    value: 1425
  },
  1430: {
    displayTime: meridiem ? '2:30 ' + 'pm' : '2:30',
    label: '2:30',
    name: '2:30',
    meridiem: 'pm',
    value: 1430
  },
  1435: {
    displayTime: meridiem ? '2:35 ' + 'pm' : '2:35',
    label: '2:35',
    name: '2:35',
    meridiem: 'pm',
    value: 1435
  },
  1440: {
    displayTime: meridiem ? '2:40 ' + 'pm' : '2:40',
    label: '2:40',
    name: '2:40',
    meridiem: 'pm',
    value: 1440
  },
  1445: {
    displayTime: meridiem ? '2:45 ' + 'pm' : '2:45',
    label: '2:45',
    name: '2:45',
    meridiem: 'pm',
    value: 1445
  },
  1450: {
    displayTime: meridiem ? '2:50 ' + 'pm' : '2:50',
    label: '2:50',
    name: '2:50',
    meridiem: 'pm',
    value: 1450
  },
  1455: {
    displayTime: meridiem ? '2:55 ' + 'pm' : '2:55',
    label: '2:55',
    name: '2:55',
    meridiem: 'pm',
    value: 1455
  },
  1500: {
    displayTime: meridiem ? '3:00 ' + 'pm' : '3:00',
    label: '3:00',
    name: '3:00',
    meridiem: 'pm',
    value: 1500
  },
  1505: {
    displayTime: meridiem ? '3:05 ' + 'pm' : '3:05',
    label: '3:05',
    name: '3:05',
    meridiem: 'pm',
    value: 1505
  },
  1510: {
    displayTime: meridiem ? '3:10 ' + 'pm' : '3:10',
    label: '3:10',
    name: '3:10',
    meridiem: 'pm',
    value: 1510
  },
  1515: {
    displayTime: meridiem ? '3:15 ' + 'pm' : '3:15',
    label: '3:15',
    name: '3:15',
    meridiem: 'pm',
    value: 1515
  },
  1520: {
    displayTime: meridiem ? '3:20 ' + 'pm' : '3:20',
    label: '3:20',
    name: '3:20',
    meridiem: 'pm',
    value: 1520
  },
  1525: {
    displayTime: meridiem ? '3:25 ' + 'pm' : '3:25',
    label: '3:25',
    name: '3:25',
    meridiem: 'pm',
    value: 1525
  },
  1530: {
    displayTime: meridiem ? '3:30 ' + 'pm' : '3:30',
    label: '3:30',
    name: '3:30',
    meridiem: 'pm',
    value: 1530
  },
  1535: {
    displayTime: meridiem ? '3:35 ' + 'pm' : '3:35',
    label: '3:35',
    name: '3:35',
    meridiem: 'pm',
    value: 1535
  },
  1540: {
    displayTime: meridiem ? '3:40 ' + 'pm' : '3:40',
    label: '3:40',
    name: '3:40',
    meridiem: 'pm',
    value: 1540
  },
  1545: {
    displayTime: meridiem ? '3:45 ' + 'pm' : '3:45',
    label: '3:45',
    name: '3:45',
    meridiem: 'pm',
    value: 1545
  },
  1550: {
    displayTime: meridiem ? '3:50 ' + 'pm' : '3:50',
    label: '3:50',
    name: '3:50',
    meridiem: 'pm',
    value: 1550
  },
  1555: {
    displayTime: meridiem ? '3:55 ' + 'pm' : '3:55',
    label: '3:55',
    name: '3:55',
    meridiem: 'pm',
    value: 1555
  },
  1600: {
    displayTime: meridiem ? '4:00 ' + 'pm' : '4:00',
    label: '4:00',
    name: '4:00',
    meridiem: 'pm',
    value: 1600
  },
  1605: {
    displayTime: meridiem ? '4:05 ' + 'pm' : '4:05',
    label: '4:05',
    name: '4:05',
    meridiem: 'pm',
    value: 1605
  },
  1610: {
    displayTime: meridiem ? '4:10 ' + 'pm' : '4:10',
    label: '4:10',
    name: '4:10',
    meridiem: 'pm',
    value: 1610
  },
  1615: {
    displayTime: meridiem ? '4:15 ' + 'pm' : '4:15',
    label: '4:15',
    name: '4:15',
    meridiem: 'pm',
    value: 1615
  },
  1620: {
    displayTime: meridiem ? '4:20 ' + 'pm' : '4:20',
    label: '4:20',
    name: '4:20',
    meridiem: 'pm',
    value: 1620
  },
  1625: {
    displayTime: meridiem ? '4:25 ' + 'pm' : '4:25',
    label: '4:25',
    name: '4:25',
    meridiem: 'pm',
    value: 1625
  },
  1630: {
    displayTime: meridiem ? '4:30 ' + 'pm' : '4:30',
    label: '4:30',
    name: '4:30',
    meridiem: 'pm',
    value: 1630
  },
  1635: {
    displayTime: meridiem ? '4:35 ' + 'pm' : '4:35',
    label: '4:35',
    name: '4:35',
    meridiem: 'pm',
    value: 1635
  },
  1640: {
    displayTime: meridiem ? '4:40 ' + 'pm' : '4:40',
    label: '4:40',
    name: '4:40',
    meridiem: 'pm',
    value: 1640
  },
  1645: {
    displayTime: meridiem ? '4:45 ' + 'pm' : '4:45',
    label: '4:45',
    name: '4:45',
    meridiem: 'pm',
    value: 1645
  },
  1650: {
    displayTime: meridiem ? '4:50 ' + 'pm' : '4:50',
    label: '4:50',
    name: '4:50',
    meridiem: 'pm',
    value: 1650
  },
  1655: {
    displayTime: meridiem ? '4:55 ' + 'pm' : '4:55',
    label: '4:55',
    name: '4:55',
    meridiem: 'pm',
    value: 1655
  },
  1700: {
    displayTime: meridiem ? '5:00 ' + 'pm' : '5:00',
    label: '5:00',
    name: '5:00',
    meridiem: 'pm',
    value: 1700
  },
  1705: {
    displayTime: meridiem ? '5:05 ' + 'pm' : '5:05',
    label: '5:05',
    name: '5:05',
    meridiem: 'pm',
    value: 1705
  },
  1710: {
    displayTime: meridiem ? '5:10 ' + 'pm' : '5:10',
    label: '5:10',
    name: '5:10',
    meridiem: 'pm',
    value: 1710
  },
  1715: {
    displayTime: meridiem ? '5:15 ' + 'pm' : '5:15',
    label: '5:15',
    name: '5:15',
    meridiem: 'pm',
    value: 1715
  },
  1720: {
    displayTime: meridiem ? '5:20 ' + 'pm' : '5:20',
    label: '5:20',
    name: '5:20',
    meridiem: 'pm',
    value: 1720
  },
  1725: {
    displayTime: meridiem ? '5:25 ' + 'pm' : '5:25',
    label: '5:25',
    name: '5:25',
    meridiem: 'pm',
    value: 1725
  },
  1730: {
    displayTime: meridiem ? '5:30 ' + 'pm' : '5:30',
    label: '5:30',
    name: '5:30',
    meridiem: 'pm',
    value: 1730
  },
  1735: {
    displayTime: meridiem ? '5:35 ' + 'pm' : '5:35',
    label: '5:35',
    name: '5:35',
    meridiem: 'pm',
    value: 1735
  },
  1740: {
    displayTime: meridiem ? '5:40 ' + 'pm' : '5:40',
    label: '5:40',
    name: '5:40',
    meridiem: 'pm',
    value: 1740
  },
  1745: {
    displayTime: meridiem ? '5:45 ' + 'pm' : '5:45',
    label: '5:45',
    name: '5:45',
    meridiem: 'pm',
    value: 1745
  },
  1750: {
    displayTime: meridiem ? '5:50 ' + 'pm' : '5:50',
    label: '5:50',
    name: '5:50',
    meridiem: 'pm',
    value: 1750
  },
  1755: {
    displayTime: meridiem ? '5:55 ' + 'pm' : '5:55',
    label: '5:55',
    name: '5:55',
    meridiem: 'pm',
    value: 1755
  },
  1800: {
    displayTime: meridiem ? '6:00 ' + 'pm' : '6:00',
    label: '6:00',
    name: '6:00',
    meridiem: 'pm',
    value: 1800
  },
  1805: {
    displayTime: meridiem ? '6:05 ' + 'pm' : '6:05',
    label: '6:05',
    name: '6:05',
    meridiem: 'pm',
    value: 1805
  },
  1810: {
    displayTime: meridiem ? '6:10 ' + 'pm' : '6:10',
    label: '6:10',
    name: '6:10',
    meridiem: 'pm',
    value: 1810
  },
  1815: {
    displayTime: meridiem ? '6:15 ' + 'pm' : '6:15',
    label: '6:15',
    name: '6:15',
    meridiem: 'pm',
    value: 1815
  },
  1820: {
    displayTime: meridiem ? '6:20 ' + 'pm' : '6:20',
    label: '6:20',
    name: '6:20',
    meridiem: 'pm',
    value: 1820
  },
  1825: {
    displayTime: meridiem ? '6:25 ' + 'pm' : '6:25',
    label: '6:25',
    name: '6:25',
    meridiem: 'pm',
    value: 1825
  },
  1830: {
    displayTime: meridiem ? '6:30 ' + 'pm' : '6:30',
    label: '6:30',
    name: '6:30',
    meridiem: 'pm',
    value: 1830
  },
  1835: {
    displayTime: meridiem ? '6:35 ' + 'pm' : '6:35',
    label: '6:35',
    name: '6:35',
    meridiem: 'pm',
    value: 1835
  },
  1840: {
    displayTime: meridiem ? '6:40 ' + 'pm' : '6:40',
    label: '6:40',
    name: '6:40',
    meridiem: 'pm',
    value: 1840
  },
  1845: {
    displayTime: meridiem ? '6:45 ' + 'pm' : '6:45',
    label: '6:45',
    name: '6:45',
    meridiem: 'pm',
    value: 1845
  },
  1850: {
    displayTime: meridiem ? '6:50 ' + 'pm' : '6:50',
    label: '6:50',
    name: '6:50',
    meridiem: 'pm',
    value: 1850
  },
  1855: {
    displayTime: meridiem ? '6:55 ' + 'pm' : '6:55',
    label: '6:55',
    name: '6:55',
    meridiem: 'pm',
    value: 1855
  },
  1900: {
    displayTime: meridiem ? '7:00 ' + 'pm' : '7:00',
    label: '7:00',
    name: '7:00',
    meridiem: 'pm',
    value: 1900
  },
  1905: {
    displayTime: meridiem ? '7:05 ' + 'pm' : '7:05',
    label: '7:05',
    name: '7:05',
    meridiem: 'pm',
    value: 1905
  },
  1910: {
    displayTime: meridiem ? '7:10 ' + 'pm' : '7:10',
    label: '7:10',
    name: '7:10',
    meridiem: 'pm',
    value: 1910
  },
  1915: {
    displayTime: meridiem ? '7:15 ' + 'pm' : '7:15',
    label: '7:15',
    name: '7:15',
    meridiem: 'pm',
    value: 1915
  },
  1920: {
    displayTime: meridiem ? '7:20 ' + 'pm' : '7:20',
    label: '7:20',
    name: '7:20',
    meridiem: 'pm',
    value: 1920
  },
  1925: {
    displayTime: meridiem ? '7:25 ' + 'pm' : '7:25',
    label: '7:25',
    name: '7:25',
    meridiem: 'pm',
    value: 1925
  },
  1930: {
    displayTime: meridiem ? '7:30 ' + 'pm' : '7:30',
    label: '7:30',
    name: '7:30',
    meridiem: 'pm',
    value: 1930
  },
  1935: {
    displayTime: meridiem ? '7:35 ' + 'pm' : '7:35',
    label: '7:35',
    name: '7:35',
    meridiem: 'pm',
    value: 1935
  },
  1940: {
    displayTime: meridiem ? '7:40 ' + 'pm' : '7:40',
    label: '7:40',
    name: '7:40',
    meridiem: 'pm',
    value: 1940
  },
  1945: {
    displayTime: meridiem ? '7:45 ' + 'pm' : '7:45',
    label: '7:45',
    name: '7:45',
    meridiem: 'pm',
    value: 1945
  },
  1950: {
    displayTime: meridiem ? '7:50 ' + 'pm' : '7:50',
    label: '7:50',
    name: '7:50',
    meridiem: 'pm',
    value: 1950
  },
  1955: {
    displayTime: meridiem ? '7:55 ' + 'pm' : '7:55',
    label: '7:55',
    name: '7:55',
    meridiem: 'pm',
    value: 1955
  },
  2000: {
    displayTime: meridiem ? '8:00 ' + 'pm' : '8:00',
    label: '8:00',
    name: '8:00',
    meridiem: 'pm',
    value: 2000
  },
  2005: {
    displayTime: meridiem ? '8:05 ' + 'pm' : '8:05',
    label: '8:05',
    name: '8:05',
    meridiem: 'pm',
    value: 2005
  },
  2010: {
    displayTime: meridiem ? '8:10 ' + 'pm' : '8:10',
    label: '8:10',
    name: '8:10',
    meridiem: 'pm',
    value: 2010
  },
  2015: {
    displayTime: meridiem ? '8:15 ' + 'pm' : '8:15',
    label: '8:15',
    name: '8:15',
    meridiem: 'pm',
    value: 2015
  },
  2020: {
    displayTime: meridiem ? '8:20 ' + 'pm' : '8:20',
    label: '8:20',
    name: '8:20',
    meridiem: 'pm',
    value: 2020
  },
  2025: {
    displayTime: meridiem ? '8:25 ' + 'pm' : '8:25',
    label: '8:25',
    name: '8:25',
    meridiem: 'pm',
    value: 2025
  },
  2030: {
    displayTime: meridiem ? '8:30 ' + 'pm' : '8:30',
    label: '8:30',
    name: '8:30',
    meridiem: 'pm',
    value: 2030
  },
  2035: {
    displayTime: meridiem ? '8:35 ' + 'pm' : '8:35',
    label: '8:35',
    name: '8:35',
    meridiem: 'pm',
    value: 2035
  },
  2040: {
    displayTime: meridiem ? '8:40 ' + 'pm' : '8:40',
    label: '8:40',
    name: '8:40',
    meridiem: 'pm',
    value: 2040
  },
  2045: {
    displayTime: meridiem ? '8:45 ' + 'pm' : '8:45',
    label: '8:45',
    name: '8:45',
    meridiem: 'pm',
    value: 2045
  },
  2050: {
    displayTime: meridiem ? '8:50 ' + 'pm' : '8:50',
    label: '8:50',
    name: '8:50',
    meridiem: 'pm',
    value: 2050
  },
  2055: {
    displayTime: meridiem ? '8:55 ' + 'pm' : '8:55',
    label: '8:55',
    name: '8:55',
    meridiem: 'pm',
    value: 2055
  },
  2100: {
    displayTime: meridiem ? '9:00 ' + 'pm' : '9:00',
    label: '9:00',
    name: '9:00',
    meridiem: 'pm',
    value: 2100
  },
  2105: {
    displayTime: meridiem ? '9:05 ' + 'pm' : '9:05',
    label: '9:05',
    name: '9:05',
    meridiem: 'pm',
    value: 2105
  },
  2110: {
    displayTime: meridiem ? '9:10 ' + 'pm' : '9:10',
    label: '9:10',
    name: '9:10',
    meridiem: 'pm',
    value: 2110
  },
  2115: {
    displayTime: meridiem ? '9:15 ' + 'pm' : '9:15',
    label: '9:15',
    name: '9:15',
    meridiem: 'pm',
    value: 2115
  },
  2120: {
    displayTime: meridiem ? '9:20 ' + 'pm' : '9:20',
    label: '9:20',
    name: '9:20',
    meridiem: 'pm',
    value: 2120
  },
  2125: {
    displayTime: meridiem ? '9:25 ' + 'pm' : '9:25',
    label: '9:25',
    name: '9:25',
    meridiem: 'pm',
    value: 2125
  },
  2130: {
    displayTime: meridiem ? '9:30 ' + 'pm' : '9:30',
    label: '9:30',
    name: '9:30',
    meridiem: 'pm',
    value: 2130
  },
  2135: {
    displayTime: meridiem ? '9:35 ' + 'pm' : '9:35',
    label: '9:35',
    name: '9:35',
    meridiem: 'pm',
    value: 2135
  },
  2140: {
    displayTime: meridiem ? '9:40 ' + 'pm' : '9:40',
    label: '9:40',
    name: '9:40',
    meridiem: 'pm',
    value: 2140
  },
  2145: {
    displayTime: meridiem ? '9:45 ' + 'pm' : '9:45',
    label: '9:45',
    name: '9:45',
    meridiem: 'pm',
    value: 2145
  },
  2150: {
    displayTime: meridiem ? '9:50 ' + 'pm' : '9:50',
    label: '9:50',
    name: '9:50',
    meridiem: 'pm',
    value: 2150
  },
  2155: {
    displayTime: meridiem ? '9:55 ' + 'pm' : '9:55',
    label: '9:55',
    name: '9:55',
    meridiem: 'pm',
    value: 2155
  },
  2200: {
    displayTime: meridiem ? '10:00 ' + 'pm' : '10:00',
    label: '10:00',
    name: '10:00',
    meridiem: 'pm',
    value: 2200
  },
  2205: {
    displayTime: meridiem ? '10:05 ' + 'pm' : '10:05',
    label: '10:05',
    name: '10:05',
    meridiem: 'pm',
    value: 2205
  },
  2210: {
    displayTime: meridiem ? '10:10 ' + 'pm' : '10:10',
    label: '10:10',
    name: '10:10',
    meridiem: 'pm',
    value: 2210
  },
  2215: {
    displayTime: meridiem ? '10:15 ' + 'pm' : '10:15',
    label: '10:15',
    name: '10:15',
    meridiem: 'pm',
    value: 2215
  },
  2220: {
    displayTime: meridiem ? '10:20 ' + 'pm' : '10:20',
    label: '10:20',
    name: '10:20',
    meridiem: 'pm',
    value: 2220
  },
  2225: {
    displayTime: meridiem ? '10:25 ' + 'pm' : '10:25',
    label: '10:25',
    name: '10:25',
    meridiem: 'pm',
    value: 2225
  },
  2230: {
    displayTime: meridiem ? '10:30 ' + 'pm' : '10:30',
    label: '10:30',
    name: '10:30',
    meridiem: 'pm',
    value: 2230
  },
  2235: {
    displayTime: meridiem ? '10:35 ' + 'pm' : '10:35',
    label: '10:35',
    name: '10:35',
    meridiem: 'pm',
    value: 2235
  },
  2240: {
    displayTime: meridiem ? '10:40 ' + 'pm' : '10:40',
    label: '10:40',
    name: '10:40',
    meridiem: 'pm',
    value: 2240
  },
  2245: {
    displayTime: meridiem ? '10:45 ' + 'pm' : '10:45',
    label: '10:45',
    name: '10:45',
    meridiem: 'pm',
    value: 2245
  },
  2250: {
    displayTime: meridiem ? '10:50 ' + 'pm' : '10:50',
    label: '10:50',
    name: '10:50',
    meridiem: 'pm',
    value: 2250
  },
  2255: {
    displayTime: meridiem ? '10:55 ' + 'pm' : '10:55',
    label: '10:55',
    name: '10:55',
    meridiem: 'pm',
    value: 2255
  },
  2300: {
    displayTime: meridiem ? '11:00 ' + 'pm' : '11:00',
    label: '11:00',
    name: '11:00',
    meridiem: 'pm',
    value: 2300
  },
  2305: {
    displayTime: meridiem ? '11:05 ' + 'pm' : '11:05',
    label: '11:05',
    name: '11:05',
    meridiem: 'pm',
    value: 2305
  },
  2310: {
    displayTime: meridiem ? '11:10 ' + 'pm' : '11:10',
    label: '11:10',
    name: '11:10',
    meridiem: 'pm',
    value: 2310
  },
  2315: {
    displayTime: meridiem ? '11:15 ' + 'pm' : '11:15',
    label: '11:15',
    name: '11:15',
    meridiem: 'pm',
    value: 2315
  },
  2320: {
    displayTime: meridiem ? '11:20 ' + 'pm' : '11:20',
    label: '11:20',
    name: '11:20',
    meridiem: 'pm',
    value: 2320
  },
  2325: {
    displayTime: meridiem ? '11:25 ' + 'pm' : '11:25',
    label: '11:25',
    name: '11:25',
    meridiem: 'pm',
    value: 2325
  },
  2330: {
    displayTime: meridiem ? '11:30 ' + 'pm' : '11:30',
    label: '11:30',
    name: '11:30',
    meridiem: 'pm',
    value: 2330
  },
  2335: {
    displayTime: meridiem ? '11:35 ' + 'pm' : '11:35',
    label: '11:35',
    name: '11:35',
    meridiem: 'pm',
    value: 2335
  },
  2340: {
    displayTime: meridiem ? '11:40 ' + 'pm' : '11:40',
    label: '11:40',
    name: '11:40',
    meridiem: 'pm',
    value: 2340
  },
  2345: {
    displayTime: meridiem ? '11:45 ' + 'pm' : '11:45',
    label: '11:45',
    name: '11:45',
    meridiem: 'pm',
    value: 2345
  },
  2350: {
    displayTime: meridiem ? '11:50 ' + 'pm' : '11:50',
    label: '11:50',
    name: '11:50',
    meridiem: 'pm',
    value: 2350
  },
  2355: {
    displayTime: meridiem ? '11:55 ' + 'pm' : '11:55',
    label: '11:55',
    name: '11:55',
    meridiem: 'pm',
    value: 2355
  },
  2300: {
    displayTime: meridiem ? '11:00 ' + 'pm' : '11:00',
    label: '11:00',
    name: '11:00',
    meridiem: 'pm',
    value: 2300
  },
  2305: {
    displayTime: meridiem ? '11:05 ' + 'pm' : '11:05',
    label: '11:05',
    name: '11:05',
    meridiem: 'pm',
    value: 2305
  },
  2310: {
    displayTime: meridiem ? '11:10 ' + 'pm' : '11:10',
    label: '11:10',
    name: '11:10',
    meridiem: 'pm',
    value: 2310
  },
  2315: {
    displayTime: meridiem ? '11:15 ' + 'pm' : '11:15',
    label: '11:15',
    name: '11:15',
    meridiem: 'pm',
    value: 2315
  },
  2320: {
    displayTime: meridiem ? '11:20 ' + 'pm' : '11:20',
    label: '11:20',
    name: '11:20',
    meridiem: 'pm',
    value: 2320
  },
  2325: {
    displayTime: meridiem ? '11:25 ' + 'pm' : '11:25',
    label: '11:25',
    name: '11:25',
    meridiem: 'pm',
    value: 2325
  },
  2330: {
    displayTime: meridiem ? '11:30 ' + 'pm' : '11:30',
    label: '11:30',
    name: '11:30',
    meridiem: 'pm',
    value: 2330
  },
  2335: {
    displayTime: meridiem ? '11:35 ' + 'pm' : '11:35',
    label: '11:35',
    name: '11:35',
    meridiem: 'pm',
    value: 2335
  },
  2340: {
    displayTime: meridiem ? '11:40 ' + 'pm' : '11:40',
    label: '11:40',
    name: '11:40',
    meridiem: 'pm',
    value: 2340
  },
  2345: {
    displayTime: meridiem ? '11:45 ' + 'pm' : '11:45',
    label: '11:45',
    name: '11:45',
    meridiem: 'pm',
    value: 2345
  },
  2350: {
    displayTime: meridiem ? '11:50 ' + 'pm' : '11:50',
    label: '11:50',
    name: '11:50',
    meridiem: 'pm',
    value: 2350
  },
  2355: {
    displayTime: meridiem ? '11:55 ' + 'pm' : '11:55',
    label: '11:55',
    name: '11:55',
    meridiem: 'pm',
    value: 2355
  },
  2400: {
    displayTime: meridiem ? '12:00 ' + 'am' : '12:00',
    label: '12:00',
    name: '12:00',
    meridiem: 'am',
    value: 2400
  }
})

export const Durations = () => {
  const arr = [];

  for (let i = 5;i < 480;i += 5) {
    arr.push({ name: FormatDuration(i), value: i })
  }

  return arr;
}

export const FormatDuration = (duration) => {
  let formatted = '';

  if (duration > 90 && duration % 60 > 0)
      formatted = Math.floor(duration / 60) + " hours & " + duration % 60 + " min";
  else if (duration > 90)
      formatted = duration / 60 + " hours";
  else
      formatted = duration + " min";

  return formatted;
}

export const GetTimezone = () => {
  return 'America/New_York'
}

export const GetMultiResourceData = (oldAppointmentResources, apptDetails) => {
  const oldResourceIdsArr = oldAppointmentResources.map(r => r.resourceId);
  const oldSelectedResourceId = apptDetails.oldEvent._def.resourceIds[0];
  const newSelectedResourceId = apptDetails.event._def.resourceIds[0];
  const index = oldResourceIdsArr.indexOf(oldSelectedResourceId);

  let multiResourceData = {};
  multiResourceData.oldEventResourceIds = oldAppointmentResources.map(r => r.resourceId);
  
  let newResourceIdsArr = oldResourceIdsArr;
  
  if (index !== -1) {
    newResourceIdsArr[index] = newSelectedResourceId;
  }

  multiResourceData.newEventResourceIds = newResourceIdsArr;

  const resourceNamesArr = oldAppointmentResources?.map(r => r.resourceName);
  let multiResource = false;
  let resourceNames = '<span>' + resourceNamesArr.join('</span>, <span>') + '</span>'
  
  if (oldAppointmentResources) {
    if (oldAppointmentResources.length > 1) {
      const lastResource = resourceNamesArr.pop();
      
      multiResource = true;
      resourceNames = '<span>' + resourceNamesArr.join('</span>, <span>') + '</span>' + ' and <span>' + lastResource + '</span>';
    }
  }

  multiResourceData.multiResource = multiResource;
  multiResourceData.resourceNamesAffectedHTML = resourceNames;
  multiResourceData.resourceChanged = oldSelectedResourceId !== newSelectedResourceId;
  multiResourceData.originalResourceId = oldSelectedResourceId;
  multiResourceData.updatedResourceId = newSelectedResourceId;

  return multiResourceData;
}

export const MatchResourceTimes = (element, response) => {
  // Find all matching resource times
  let matchingTimes = [];
  response.availableTimes.forEach(timeSlot => {
    if (response.availableTimes.filter(t => timeSlot.startDateTime === t.startDateTime).length === element.params.resourceIds.replace(' ').split(',').length) {
      // There are the same number of resource ids as matching times
      let multiResourceTimeSlot = timeSlot;
      // Remove single Resource ID
      delete multiResourceTimeSlot.resourceId;
      // Add all Resource IDs
      multiResourceTimeSlot.resourceIds = element.params.resourceIds;
      // Add matching time data
      matchingTimes.push(timeSlot);
    }
  })

  // Filter out duplicate times
  let filteredTimes = [];
  matchingTimes.forEach(timeSlot => {
    if (!filteredTimes.filter(t => timeSlot.startDateTime === t.startDateTime).length) {
      // Filtered array does not yet contain time
      let newTime = timeSlot;
      delete newTime.resourceId;
      newTime.resourceIds = element.params.resourceIds;
      filteredTimes.push(timeSlot);
    }
  })

  let filteredResponse = response;
  filteredResponse.availableTimes = filteredTimes;

  return filteredResponse;
}

export const ClickAvailabilityWindow = (e, searching, setSearching, deselected, deselect) => {
  if (searching) {
    if (!e.target.className.includes('SearchDropdownResults') &&
    !e.target.className.includes('SearchDropdownResult') &&
    !e.target.className.includes('SearchDropdownInput') &&
    !e.target.className.includes('SearchDropdown')
    ) {
      setSearching(false);
    }
  }
  else if (!deselected) {
    deselect(true);
  }
}

export const IsMonthView = (element) => {
  if (element.options.calendarType === 'month' || 
    element.options.calendarType === 'month-side' || 
    !element.options.calendarType) {
      return true;
  }
  else return false;
}

export const CustomDays = (element) => {
  const isLg = s => document.getElementById(element.id).classList.contains('md') ? s : s.slice(0,1);
  const day = d => OnSchedUtils.Internationalize(element, `consumer_availability_weekday_${d}`);

  return [
    isLg(day('sun')), 
    isLg(day('mon')), 
    isLg(day('tue')), 
    isLg(day('wed')), 
    isLg(day('thu')), 
    isLg(day('fri')), 
    isLg(day('sat'))
  ];
}

export const CustomMonths = (element) => {
  const month = m => OnSchedUtils.Internationalize(element, `consumer_availability_month_${m}`);

  return [
    month('jan'), 
    month('feb'), 
    month('mar'), 
    month('apr'), 
    month('may'), 
    month('jun'), 
    month('jul'), 
    month('aug'), 
    month('sep'), 
    month('oct'), 
    month('nov'), 
    month('dec')
  ]
}

export const HandleInitialAvailabilityLoad = (element, resp, picker, setAvailability, date, setDate, setBookingTimerMins) => {
  // Set the availability response
  setAvailability(resp);
  // Figure out First Available
  OnSchedUtils.JumpToFirstAvailable(element, resp.availableDays, picker, date, setDate)
  // Check Disabled Days
  OnSchedUtils.CalendarDayDisabler(element, moment(date).format('YYYY-MM-DD'), resp);
  // Update color scheme (whatever tf this is)
  OnSchedUtils.UpdateOnSchedAvailabilityCalendarColorScheme();

  // Booking Timer Minutes
  GetLocation(element, { id: resp.locationId })
    .then(location => setBookingTimerMins(location.settings.bookingTimerMins));
  
  // End Loading
  OnSchedUtils.Loading(element, false, false);
}

export const CalendarDayDisabler = (element, date, availability) => {
  if (availability) {
    // Disable dates
    // Find all dates
    const calendarDates = [...document.querySelectorAll('.qs-num')]
      .map(d => d.innerText.length > 1 ? 
        date.slice(0, 8) + d.innerText : 
        date.slice(0, 8) + '0' + d.innerText
      );
    
    // Compare against available days
    if (availability.availableDays) {
      calendarDates.map(date => {
        let dayAvailability = availability.availableDays.filter(d => d.date === date)[0];
        if (element.options.bookAheadDate) {
          if (moment(dayAvailability.date).isAfter(moment(element.options.bookAheadDate))) {
            dayAvailability.available = false;
          }
        }
        if (element.options.bookInAdvanceDate) {
          if (moment(dayAvailability.date).isBefore(moment(element.options.bookAheadDate))) {
            dayAvailability.available = false;
          }
        }

        const dayEl = document.querySelectorAll('.qs-num')[parseInt(dayAvailability?.date.slice(8)) - 1];

        if (dayAvailability?.available) {
          if (dayEl.classList.contains('qs-disabled')) {
            dayEl.classList.remove('qs-disabled');
          }
        }
        else if (dayEl && !dayEl.classList.contains('qs-disabled')) {
          dayEl.classList.add('qs-disabled');
        }
      })
    }
  }
}

export const OnAvailableDaySelect = ({element, instance, date, initialDate, timezoneName, setDate, setAvailability}) => {
  const timezone = element.options.timezone !== false ? document.getElementById('timezoneName-input').dataset.timezoneName : timezoneName;
  // Check if the date is already selected
  if (moment(date).format('YYYY-MM-DD') !== initialDate) {
    // Do stuff when a date is selected (or unselected) on the calendar.
    // You have access to the datepicker instance for convenience.
    OnSchedUtils.Loading(element, true, true, 'Availability');

    GetAvailability(element, date, timezone)
      .then(response => {
        // Set the availability response
        setAvailability(response);
        setDate(moment(date).format('YYYY-MM-DD'));

        // If month veiw
        if (instance) {
          // Set the picker date
          instance.setDate(date);
          
          // Check Disabled Days
          OnSchedUtils.CalendarDayDisabler(element, moment(date).format('YYYY-MM-DD'), response);
          
          // Update color scheme (whatever tf this is)
          OnSchedUtils.UpdateOnSchedAvailabilityCalendarColorScheme();
        }
  
        OnSchedUtils.Loading(element, false);
      });
  }
}

export const OnAvailableMonthChange = (element, instance, timezoneName, setDate, setAvailability) => {
  // CHECK IF FIRST OF MONTH IS DISABLED BEFORE TRYING TO SET
  //
  // SAVE THE FIRST AVAILABLE DATE THAT WAS SET
  //
  // IF EARLIER THAN FIRST AVAILALBLE, SET FIRST AVAILABLE
  //
  //
  
  // Do stuff when a month is changed on the calendar.
  // You have access to the datepicker instance for convenience.
  const timezone = element.options.timezone !== false ? document.getElementById('timezoneName-input').dataset.timezoneName : timezoneName;
  const date = new Date(instance.currentYear, instance.currentMonth, 1);

  OnSchedUtils.Loading(element, true, true, 'Availability');

  const handleResponse = (resp, date) => {
    // Set the availability response
    setAvailability(resp);
    setDate(moment(date).format('YYYY-MM-DD'));

    // Set the picker date
    instance.setDate(new Date(date));
    instance.navigate(new Date(date));
    
    // Check Disabled Days
    OnSchedUtils.CalendarDayDisabler(element, moment(date).format('YYYY-MM-DD'), resp);
    
    // Update color scheme (whatever tf this is)
    OnSchedUtils.UpdateOnSchedAvailabilityCalendarColorScheme();

    OnSchedUtils.Loading(element, false);
  }
  
  GetAvailability(element, moment(date).format('YYYY-MM-DD'), timezone)
    .then(response => {
      // Check available days
      if (response.availableDays.filter(d => d.date === moment(date).format('YYYY-MM-DD'))[0].available) {
        // Day is available
        handleResponse(response, date)
      }
      else {
        // Day is not available
        const firstAvailable = response.availableDays.filter(d => d.available)[0]?.date;

        if (firstAvailable) {
          GetAvailability(element, firstAvailable, timezone)
            .then(response2 => {
              handleResponse(response2, new Date(firstAvailable.replace('-', '/')));
            })
        }
        else {
          handleResponse(response, date);
          OnSchedUtils.Toast(element, { error: true, message: OnSchedUtils.Internationalize(element, 'consumer_availability_none') })
          OnSchedUtils.Loading(element, false);
        }
      }
    });
};

export const FirstAvailableInWeek = (date, availability) => {
  const startOfWeek = moment(date).startOf('week').format('YYYY-MM-DD');
  const endOfWeek = moment(date).endOf('week').format('YYYY-MM-DD');
  const availableDays = availability?.availableDays.filter(d => moment(d.date).isBetween(startOfWeek, endOfWeek) && d.available)
                                                   .map(d => d.date);

  if (availableDays.length)
    return availableDays[0];
  else 
    return false
}